var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "v-layout",
        { attrs: { "justify-end": "" } },
        [
          _c(
            "v-flex",
            [
              _c(
                "v-col",
                { staticClass: "pr-0" },
                [
                  _c(
                    "v-btn",
                    {
                      staticStyle: { color: "white" },
                      attrs: {
                        "data-test": "aggiungi-variazione",
                        color: "green lighten-2",
                      },
                      on: { click: _vm.openDialog },
                    },
                    [
                      _vm._v(" Nuova Riga "),
                      _c("v-icon", { attrs: { right: "" } }, [
                        _vm._v("mdi-plus"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-flex",
            [
              _c(
                "v-col",
                { staticClass: "pr-0", attrs: { align: "right" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        "data-test": "conferma-variazione",
                        color: "primary",
                        disabled:
                          !_vm.containsVariazioni || !_vm.variazioniValide,
                      },
                      on: { click: _vm.confermaVariazione },
                    },
                    [
                      _vm._v(" Conferma Variazione "),
                      _c("v-icon", { attrs: { right: "" } }, [
                        _vm._v("mdi-check"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-card",
        [
          _vm._l(_vm.listaVariazioniDaComunicare, function (row, i) {
            return [
              i > 0 ? _c("v-divider", { key: "d_" + i }) : _vm._e(),
              _c(
                "v-row",
                {
                  key: "r_" + i,
                  attrs: { "data-test": "riga-componente", "no-gutters": "" },
                },
                [
                  _c(
                    "div",
                    { staticStyle: { "background-color": "#f2f2f2" } },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "col-indice",
                          attrs: { "align-self": "center" },
                        },
                        [
                          _c("p", { staticClass: "text-center" }, [
                            _vm._v(_vm._s(row.rigaDistinta.indiceRiga)),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "col-dati",
                      class: {
                        "modified-field":
                          _vm.isModified(row) ||
                          _vm.isNuova(row) ||
                          _vm.contieneModificheCorrelate(row),
                        "deleted-field": _vm.isDeleted(row),
                        "deleted-from-as400": row.eliminataDaAs400,
                      },
                    },
                    [
                      _c(
                        "v-row",
                        [
                          _c("v-col", [
                            !_vm.isNuova(row) &&
                            !row.rigaDistinta.richiestaDiInserimento
                              ? _c("div", [
                                  row.eliminataDaAs400
                                    ? _c("em", [
                                        _vm._v("ELIMINATA DA AS 400 "),
                                        _c("br"),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" Componente: "),
                                  _c(
                                    "strong",
                                    { attrs: { "data-test": "componente" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          row.rigaDistinta.innerRigaDistinta
                                            .componente
                                        ) +
                                          " (" +
                                          _vm._s(
                                            row.rigaDistinta.innerRigaDistinta
                                              .idComponenteBga
                                          ) +
                                          ")"
                                      ),
                                    ]
                                  ),
                                  _vm._v(
                                    " - " +
                                      _vm._s(
                                        row.rigaDistinta.innerRigaDistinta
                                          .descri
                                      )
                                  ),
                                  _c("br"),
                                  _vm._v(" Colore: "),
                                  _c(
                                    "strong",
                                    { attrs: { "data-test": "colore" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          row.rigaDistinta.innerRigaDistinta
                                            .coloreComponente
                                        ) +
                                          " (" +
                                          _vm._s(
                                            row.rigaDistinta.innerRigaDistinta
                                              .idColoreComponenteBgf
                                          ) +
                                          ")"
                                      ),
                                    ]
                                  ),
                                  _vm._v(" , Unità di misura: "),
                                  _c(
                                    "strong",
                                    {
                                      attrs: { "data-test": "unita-di-misura" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          row.rigaDistinta.innerRigaDistinta
                                            .unMisuraDiBa
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" , id: "),
                                  _c("em", [
                                    _vm._v(
                                      _vm._s(
                                        row.rigaDistinta.innerRigaDistinta.idBgj
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("br"),
                                ])
                              : _c("div", [
                                  _c("strong", [
                                    _vm._v(
                                      "Riga inserita in attesa di validazione"
                                    ),
                                  ]),
                                  _c("br"),
                                  _vm._v("Componente: "),
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        row.rigaDistinta.innerRigaDistinta
                                          .idComponenteBga
                                      )
                                    ),
                                  ]),
                                  _vm._v(" - Colore: "),
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        row.rigaDistinta.innerRigaDistinta
                                          .idColoreComponenteBgf
                                      )
                                    ),
                                  ]),
                                  _vm._v(", Unità di misura: "),
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        row.rigaDistinta.innerRigaDistinta
                                          .unMisuraDiBa
                                      )
                                    ),
                                  ]),
                                ]),
                          ]),
                          row.rigaDistinta.inAttesaDiSincronizzazione
                            ? _c(
                                "v-col",
                                { attrs: { sm: "2", md: "1" } },
                                [
                                  _c(
                                    "v-container",
                                    { attrs: { "fill-height": "", fluid: "" } },
                                    [
                                      _c(
                                        "v-layout",
                                        {
                                          attrs: {
                                            row: "",
                                            wrap: "",
                                            "align-center": "",
                                            "justify-center": "",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                title:
                                                  "Riga con variazioni in attesa di sincronizzazione",
                                                color: "primary",
                                              },
                                            },
                                            [_vm._v("mdi-cloud-sync")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : row.rigaDistinta.conVariazioniConsolidate
                            ? _c(
                                "v-col",
                                { attrs: { sm: "2", md: "1" } },
                                [
                                  _c(
                                    "v-container",
                                    { attrs: { "fill-height": "", fluid: "" } },
                                    [
                                      _c(
                                        "v-layout",
                                        {
                                          attrs: {
                                            row: "",
                                            wrap: "",
                                            "align-center": "",
                                            "justify-center": "",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                title:
                                                  "Riga con variazioni consolidate",
                                                color: "green",
                                              },
                                            },
                                            [_vm._v("mdi-cloud-check")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        { staticStyle: { "margin-left": "0px" } },
                        [
                          !row.rigaDistinta.inAttesaDiSincronizzazione
                            ? _c(
                                "div",
                                [
                                  !_vm.isDeleted(row)
                                    ? _c("TabellaValori", {
                                        attrs: { rigaDistinta: row },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                          !row.rigaDistinta.richiestaDiInserimento &&
                          row.rigaDistinta.variazioniComunicate &&
                          row.rigaDistinta.variazioniComunicate.length > 0
                            ? _c("RigaDistintaListaVariazioni", {
                                staticStyle: { "margin-top": "10px" },
                                attrs: { "riga-distinta": row.rigaDistinta },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  !row.rigaDistinta.inAttesaDiSincronizzazione
                    ? _c(
                        "v-col",
                        {
                          class: {
                            "modified-field":
                              _vm.isModified(row) ||
                              _vm.isNuova(row) ||
                              _vm.contieneModificheCorrelate(row),
                            "deleted-field": _vm.isDeleted(row),
                            "deleted-from-as400": row.eliminataDaAs400,
                          },
                          attrs: { sm: "2", md: "1" },
                        },
                        [
                          !row.eliminataDaAs400
                            ? _c(
                                "v-container",
                                { attrs: { "fill-height": "", fluid: "" } },
                                [
                                  _c(
                                    "v-layout",
                                    {
                                      attrs: {
                                        row: "",
                                        wrap: "",
                                        "align-center": "",
                                        "justify-center": "",
                                      },
                                    },
                                    [
                                      _vm.isDeleted(row)
                                        ? _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                fab: "",
                                                dark: "",
                                                small: "",
                                                color: "orange",
                                                "data-test": "undo-variazione",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.undoVariazione(row)
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { dark: "" } },
                                                [_vm._v("mdi-undo")]
                                              ),
                                            ],
                                            1
                                          )
                                        : _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                fab: "",
                                                dark: "",
                                                small: "",
                                                color: "red",
                                                "data-test":
                                                  "elimina-variazione",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.eliminaVariazione(
                                                    row
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { dark: "" } },
                                                [_vm._v("mdi-delete")]
                                              ),
                                            ],
                                            1
                                          ),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            fab: "",
                                            dark: "",
                                            small: "",
                                            color:
                                              _vm.contieneModificheCorrelate(
                                                row
                                              )
                                                ? "purple"
                                                : "blue",
                                          },
                                          on: {
                                            click: function ($event) {
                                              row.mostraCorrelate =
                                                !row.mostraCorrelate
                                            },
                                          },
                                        },
                                        [
                                          row.mostraCorrelate
                                            ? _c(
                                                "v-icon",
                                                { attrs: { dark: "" } },
                                                [
                                                  _vm._v(
                                                    "mdi-layers-triple-outline"
                                                  ),
                                                ]
                                              )
                                            : _c(
                                                "v-icon",
                                                { attrs: { dark: "" } },
                                                [_vm._v("mdi-layers-triple")]
                                              ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _c("v-col", { attrs: { sm: "2", md: "1" } }),
                  row.mostraCorrelate
                    ? _c(
                        "v-row",
                        { staticStyle: { width: "100%" } },
                        [
                          _c("VariazioniMassive", {
                            staticStyle: { width: "100%" },
                            attrs: { "variazione-riferimento": row },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          }),
        ],
        2
      ),
      _c("DialogNewVariazione", {
        ref: "dialogNuovaVariazione",
        attrs: { idDistinta: _vm.idDistinta },
        on: { "variazione-creata": _vm.onVariazioneCreata },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }